export default {"src":"/_next/static/media/remove-circle-outline.d0c02065.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};